import React from 'react';

const DimensionFormatter = (props) => {
  const { rowData } = props.dependentValues;
  let description;
  if (rowData && rowData.dimensionReference) {
    description = rowData.dimensionReference.description;
  } else {
    return <div />;
  }

  return <div title={description}>{description}</div>;
};

export default DimensionFormatter;
